module.exports = __webpack_public_path__ + "img/icono-facebook.e1e8afc0.svg";